<template>
  <div class="v-button" :style="btnStyle">
    <el-button v-bind="$attrs" :type="type" :class="disStyle" @click.stop="handleClick">
      <slot name="iconBtn"></slot>{{ name }}
    </el-button>
  </div>
</template>

<script>
export default {
  name: 'VButton',
  props: {
    name: {
      type: String,
      default: '',
    },
    type: {
      // normal-> 正常（篮框白底）normal-bg -> 正常（蓝底白字） del -> 删除的颜色（白底橙色）del-bg -> 删除的颜色（橙色底） text-normal -> 文字(蓝) text-warning -> 文字（橙）
      type: String,
      default: 'normal',
    },
    right: {
      // 右边距
      type: Number,
      default: 0,
    },
    left: {
      // 左边距
      type: Number,
      default: 0,
    },
    fontSize: {
      // 按钮字体
      type: Number,
      default: 0,
    },
    initial: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    btnStyle() {
      const atrrList = ['left', 'right'];
      const styleObj = {};
      atrrList.map((item) => {
        if (this[item]) {
          Object.assign(styleObj, {
            [`margin-${item}`]: `${this[item]}px`,
          });
        }
      });
      if (this.initial) {
        Object.assign(styleObj, {
          width: 'initial',
          height: 'initial',
        });
      }
      return styleObj;
    },
    disStyle() {
      var className = '';
      if (this.disabled) {
        if (this.type.indexOf('bg') > -1) {
          className = 'el-button--bg-disabled';
        } else if (this.type.indexOf('text') > -1) {
          className = 'el-button--text-disabled';
        } else {
          className = 'el-button--disabled';
        }
      } else {
        className = '';
      }
      return className;
    },
  },
  methods: {
    handleClick() {
      if (!this.disabled) this.$emit('click');
    },
  },
};
</script>

<style lang="scss">
@import '@/styles/color.scss';
@import '@/styles/mixin.scss';
@import '@/styles/font.scss';

.v-button {
  // width: inherit;
  height: inherit;
  display: table-cell;
  line-height: 1;
  border-radius: 4px;
  font-size: $font14;
  cursor: pointer;

  &.font14 {
    .el-button--text-normal {
      font-size: $font14;
      padding: 1px;
    }
  }

  .el-button {
    width: inherit;
    height: inherit;
    display: table-cell;
    vertical-align: middle;
    text-align: center;
    transition: none;

    &__name {
      display: flex;
      justify-content: center;
      align-items: center;
      white-space: nowrap;
    }

    &--medium {
      padding: 12px 15px;
      font-size: $font18;
      line-height: 18px;
    }

    &--small {
      padding: 8px 15px;
      padding: 7px 15px;
      font-size: $font14;
      line-height: 14px;
      min-width: 64px;
    }

    &--mini {
      padding: 5px 11px;
      font-size: $font12;
      line-height: 12px;
    }

    &--normal {
      color: $blueNormal !important;
      @include border($blueNormal);
      background-color: $white;

      &:hover {
        @include border($blueHover);
        color: $blueHover;
      }
    }

    &--normal-bg {
      color: $white;
      @include border($blueNormal);
      background-color: $blueNormal;
    }

    &--del {
      color: $warn;
      @include border($warn);
      background: $white;
    }

    &--del-bg {
      background: $warn;
      @include border($warn);
      color: $white;
    }

    &--disabled {
      @include border($disabled);
      color: $disabled;

      &:hover {
        cursor: not-allowed;
        @include border($disabled);
        color: $disabled;
        background: $white;
      }
    }

    &--bg-disabled {
      @include border($disabled);
      color: $white;
      background: $disabled;

      &:hover {
        cursor: not-allowed;
        @include border($disabled);
        color: $white;
        background: $disabled;
      }
    }

    &--text-normal {
      color: $blueNormal;
      text-decoration: underline;
      border: none;
      padding: 0;
      background: $white;
      font-size: $font12;
    }

    &--text-warning {
      color: $warn;
      text-decoration: underline;
      border: none;
      padding: 0;
      background: $white;
      font-size: $font12;
    }

    &--text-border {
      color: $blueNormal;
      text-decoration: underline;
      border: 1px solid $blueNormal;
      padding: 0;
      background: $white;
      font-size: $font12;
    }

    &--text-disabled {
      color: $disabled;
      text-decoration: underline;
      border: none;
      padding: 0;
      background: $white;
      font-size: $font12;

      &:hover {
        cursor: not-allowed;
        color: $disabled;
        text-decoration: underline;
        background: $white;
      }
    }

    &:hover {
      opacity: 0.8;
    }

    &:active {
      opacity: 0.7;
    }

    .el-icon-delete {
      margin-right: 2px;
    }
  }
}
</style>
